import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserProfile, signOutUser, fetchUserData } from '../store/slices/authslice';
import { toast } from 'react-toastify';

const AccountComponent = () => {
  const dispatch = useDispatch();
  const { user, orders, loading, error } = useSelector((state) => state.auth);
  const [editMode, setEditMode] = useState(false);
  const [profile, setProfile] = useState({
    username: '',
    phone: '',
    address: '',
  });

  // When user data is available, update the local form state.
  useEffect(() => {
    if (user) {
      setProfile({
        username: user.username || '',
        phone: user.phone || '',
        address: user.address || '',
      });
    }
  }, [user]);

  const handleChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    dispatch(updateUserProfile(profile));
    toast.success("Profile updated successfully!");
    setEditMode(false);
  };

  const handleSignOut = () => {
    dispatch(signOutUser());
    toast.info("Signed out successfully!");
  };

  return (
    <div className="min-h-screen bg-black text-red-500 p-4">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold mb-6 text-center">My Account</h2>
        
        {/* Profile Card */}
        <div className="bg-gray-900 p-6 rounded-lg shadow-lg">
          <h3 className="text-2xl font-semibold mb-4">Profile Information</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-gray-400 mb-1">Username</label>
              {editMode ? (
                <input
                  type="text"
                  name="username"
                  value={profile.username}
                  onChange={handleChange}
                  className="w-full p-2 bg-black border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
                />
              ) : (
                <p>{user?.username || 'N/A'}</p>
              )}
            </div>
            <div>
              <label className="block text-gray-400 mb-1">Phone</label>
              {editMode ? (
                <input
                  type="text"
                  name="phone"
                  value={profile.phone}
                  onChange={handleChange}
                  className="w-full p-2 bg-black border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
                />
              ) : (
                <p>{user?.phone || 'N/A'}</p>
              )}
            </div>
            <div className="md:col-span-2">
              <label className="block text-gray-400 mb-1">Address</label>
              {editMode ? (
                <textarea
                  name="address"
                  value={profile.address}
                  onChange={handleChange}
                  className="w-full p-2 bg-black border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
                />
              ) : (
                <p>{user?.address || 'N/A'}</p>
              )}
            </div>
          </div>
          <div className="mt-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            {/* {editMode ? (
              <>
                <button
                  onClick={handleSave}
                  className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg"
                >
                  Save
                </button>
                <button
                  onClick={() => setEditMode(false)}
                  className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg"
                >
                  Cancel
                </button>
              </>
            ) : (
              <button
                onClick={() => setEditMode(true)}
                className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg"
              >
                Edit Profile
              </button>
            )} */}
            <button
              onClick={handleSignOut}
              className="ml-auto px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg"
            >
              Sign Out
            </button>
          </div>
        </div>

        {/* Orders Card */}
        <div className="bg-gray-900 p-6 rounded-lg shadow-lg mt-6">
          <h3 className="text-2xl font-semibold mb-4">My Orders</h3>
          {orders && orders.length > 0 ? (
            <div className="space-y-4">
              {orders.map((order) => (
                <div key={order.id} className="p-4 border border-gray-700 rounded-lg">
                  <p className="font-medium">
                    Order ID: <span className="text-red-500">{order.id}</span>
                  </p>
                  <p>
                    Total Amount: <span className="text-red-500">₦{order.totalAmount.toLocaleString()}</span>
                  </p>
                  <p>
                    Status: <span className="text-red-500">{order.status}</span>
                  </p>
                  <p>
                    Placed On: <span className="text-red-500">{new Date(order.createdAt).toLocaleString()}</span>
                  </p>
                </div>
              ))}
            </div>
          ) : (
            <p>No orders found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AccountComponent;
